import store from "src/Reducers/store";
import * as appActions from "src/Actions/appActions";

const setCurrentUser = (user: string) => store.dispatch(appActions.setCurrentUser(user));

export default setCurrentUser;
